import styled from 'styled-components';
import { rem } from 'polished';
import Image from '../Image';
import Avatar from '../../../../assets/images/Avatar.jpg';
import AvatarPerson from '../AvatarPerson';
// import { rem } from 'polished';

const StyledCredit = styled.div`
  align-items: center;
  display: flex;
`;
// Capa para los textos
const StyledText = styled.div`
  display: inline-block;
  margin: 0 0.5rem;
`;
// Texto autor de la noticia
const StyledAuthor = styled.p`
  font-family: ${props => props.theme.fonts.medium};
  font-size: ${props => props.theme.fontSize.small};
  line-height: 1rem;
  margin: 0;
`;
// Texto si hay autor  de la noticia
const StyledSeccion = styled.p`
  font-family: ${props => props.theme.fonts.book};
  font-size: ${props => props.theme.fontSize.xsmall};
  line-height: 1rem;
  margin: 0;
`;
// Texto si hay autor  de la noticia
const StyledImgAvatar = styled(Image)`
  width: 2.5rem;
`;

// Capa para la imagen de Avatar
const StyledAvatar = styled.div`
  background-color: ${props => props.theme.colors.gray};
  background-position: 50% 50%;
  background-size: cover;
  border-radius: 50%;
  border: 0.1875rem solid ${props => props.theme.colors.dark};
  display: inline-block;
  height: 2.8125rem;
  overflow: hidden;
  position: relative;
  width: 2.8125rem;
  background-image: url(${Avatar});
`;

const StyledAvatarPerson = styled(AvatarPerson)`
  font-size: ${rem('21px')};
`;

export {
  StyledCredit,
  StyledAvatar,
  StyledText,
  StyledAuthor,
  StyledSeccion,
  StyledImgAvatar,
  StyledAvatarPerson
};
